import { Grid } from "@mui/material";
import dayjs from "dayjs";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { callAPI, getLocalValue, handleApiError, IsSmallScreen, LoacalVariables, Method } from "../../../commonFunctions/CommonFunctions";
import PermissionDenied from "../../../commonFunctions/PermissionDenied";
import { AllPermissions } from "../../../commonFunctions/PermissionManger";
import WSDataGrid, { IColumns } from "../../../Components/DataGrid/WSDataGrid";
import { IOrderColumns } from "../../../Components/DataGrid/WSMobileDataGridAdvanced";
import SwipeableDrawerForm from "../../../Components/DrawyerForm/DrawyerForm";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import { resetDataComponent, storeDataComponent, updateDataComponent } from "../../../StateManagement/actions";
import TaskAssign from "../../Contacts/ContactDetails/DrawyerPages/TaskAssign";
import TaskDrawyer from "../../Contacts/ContactDetails/DrawyerPages/TaskDrawyer";
import { ITask } from "../../DTO/Dto";

export const OverViewSurveyor: React.FC<any> = React.memo((props) => {
    const { showMessage } = useSnackbar();
    const dispatch = useDispatch()
    const params = useParams();
    const { id } = params
    const [open, setOpen] = React.useState(false);
    const [taskListData, setTaskListData] = useState<any>([])
    const [resetLoad, setResetLoad] = useState(false)
    const [loading, setLoading] = useState(false)
    const { control, register, handleSubmit, setValue, reset } = useForm();
    const [formComponent, setFormComponent] = useState<any>()
    AllPermissions.getInstance();
    const { add, edit, remove, view } = AllPermissions.getTaskPermission;
    const resetTrigger = useSelector((state: any) => state.components?.contactTaskGrid?.resetTrigger);
    const isMobile = IsSmallScreen();
    const navigate = useNavigate();
    const source = {
        url: 'search',
        "page": 1,
        "pageSize": 10,
        "filter": [
            {
                "field": "leadId",
                "operator": "eq",
                "value": id
            }
        ],
        "sort": [

        ]
    }
    useEffect(() => {

        const getTasks = async () => {
            try {
                setResetLoad(false)
                const response: any = await callAPI(`tasks/lead`, Method.GET, null, id);
                if (response && response.data) {
                    setTaskListData(response.data);
                }
            }
            catch (e) {
            }
        }
        getTasks();
    }, [resetTrigger])
    useEffect(() => {

        const getTasks = async () => {
            try {
                setResetLoad(false)
                const response: any = await callAPI(`tasks/lead`, Method.GET, null, id);
                if (response && response.data) {
                    setTaskListData(response.data);
                }
            }
            catch (e) {
            }
        }
        getTasks();
    }, [resetLoad])
    const columns: IColumns[] = [
        {
            header: "Name",
            fieldName: "surveyorName",
            tooltip: true,
            type: 'default'
        },
        {
            header: "Phone",
            fieldName: "phoneNumber",
            tooltip: true,
            type: 'default'
        },
        {
            header: "Status",
            fieldName: "status",
            tooltip: true,
            type: 'status',
            isHide: isMobile
        },
        {
            header: "Actions",
            fieldName: "actions",
            type: "action",
            actions: [edit ? "Assign Task" : undefined, "View"].filter(Boolean),
            actionCallback: (action, row) => handleAction(action, row),
            hideSelectedActions: {
                fieldToShow: [
                    {
                        field: "status",
                        showActions: ["View"],
                        showValue: ['Report Submitted']
                    },
                    {
                        field: "status",
                        showActions: ["Assign Task"],
                        showValue: ['Accepted']
                    },
                ],
                // fieldToHide: [
                //     {
                //         field: "status",
                //         hideActions: ["Assign Task"],
                //         hideValue: ['Report Submitted', 'Task Assigned','Pending']
                //     },

                // ],
            }
        },
    ];
    const mobColumns: IOrderColumns[] = [
        {
            header: "Task",
            fieldName: "taskName",
            tooltip: true,
            type: 'default',
            sm: 6
        },
        {
            header: "Task Date",
            fieldName: "customDate",
            tooltip: true,
            type: 'date',
            sm: 6
        },
        {
            header: "Task type",
            fieldName: "taskType",
            tooltip: true,
            type: 'default'
        },
        {
            header: "Actions",
            fieldName: "actions",
            type: "action",
            actions: [edit ? "Assign Task" : undefined, "View"].filter(Boolean),
            actionCallback: (action, row) => handleAction(action, row),


        },
    ];
    const handleAction = async (action: string, row: any) => {
        if (action === "Assign Task") {
            const form: any = <TaskAssign
                id={id}
                control={control}
                register={register}
                data={row}
                loading={loading}
                // taskId={row.id}
                isDisableUser={true}
                reset={reset}
                setValue={setValue}
                onCancel={() => { reset(); setOpen(false); setFormComponent(null) }}

            />

            setFormComponent(form)
            setTimeout(() => {
                setOpen(true)
            }, 10);
        } else if (action === "View") {
            navigate(`/contact/edit/${id}/view-surveyor/${row?.notificationLogId}`, {
                state: { row }
            })
        }
    }

    const handleTasksData = async (data: any) => {
        try {
            dispatch(storeDataComponent('taskSubmitAss', { loading: true }));
            const response: any = await saveData(data);
            if (response?.errors) {
                const mess = handleApiError(response)
                showMessage(mess, 'error');
            }
            else if (response && response?.message) {
                dispatch(resetDataComponent('overViewSurveyorGrid'));
                reset()
                setResetLoad(true)
                showMessage(response.message, response.success === true ? 'success' : 'error')
            } else if (response?.id) {
                dispatch(resetDataComponent('overViewSurveyorGrid'));
                setResetLoad(true)
                showMessage('Task Created Successfully', 'success')
            }
        } catch (e: any) {
            showMessage(e.error);
            setResetLoad(true)
        }
        finally {
            dispatch(updateDataComponent('taskSubmitAss', { loading: false }));
        }
    }
    const saveData = async (data: ITask) => {
        const isoString: any = dayjs(`${data?.customDate} 00:00`, "DD-MM-YYYY HH:mm").toISOString();
        const request: ITask = {
            taskName: data?.taskName || "",
            activityDate: data?.activityDate?.toString() || "",
            activityTime: data?.activityTime || "",
            customDate: isoString || "",
            assignedToUserId: data?.assignedToUserId || getLocalValue(LoacalVariables.UserId),
            leadId: id || "",
            customReminderTime: data.customReminderTime,
            notes: data?.notes || "",
            priority: data?.priority || "",
            queue: data?.queue || "",
            reminder: data?.reminder?.toString() || "",
            reminderSent: data?.reminderSent || false,
            taskType: data?.taskType || "",

        }
        // if (data?.taskId) {
        //     const response: any = await callAPI(`assign-task/`, Method.PUT, request, data?.taskId);
        //     return response
        // } else {
        const response: any = await callAPI(`assign-task/${data?.notificationId}/${data?.assignedToUserId}`, Method.POST, request);
        return response
        // }

    }
    const transFormData = (data: any) => {
        data?.map((item: any) => {
            item.status = item.status === 'ReportSubmitted' ? 'Report Submitted' : item.status
        })
        return data
    }

    return (
        <    >
            <Grid container spacing={0} sx={{ p: 0, borderRadius: 5 }}>
                {view ? <Grid item xs={12}>
                    {<WSDataGrid isAccordian={true}
                        id="overViewSurveyorGrid"
                        title="Surveyors"
                        // data={taskListData}
                        transFormData={transFormData}
                        source={source}
                        columns={columns}
                        // addButton={add ? { label: "New", color: "secondary" } : undefined}
                        // onAddButtonClick={handleTaskClick}
                       
                    />}
                    {/* {isMobile && taskListData.length>0 &&
            <WSMobileDataGridAdvanced title={'Tasks'} addButton={add ? { label: "New", color: "secondary" } : undefined}
              onAddButtonClick={handleTaskClick} columns={mobColumns} id="estimationGrid" data={taskListData} />
          } */}
                </Grid>
                    : <PermissionDenied />}
            </Grid>
            {formComponent && <SwipeableDrawerForm anchor="right" title={'Tasks'} isMobile={isMobile}
                openForm={open}
                formComponent={<form onSubmit={handleSubmit(handleTasksData)}>
                    {formComponent}
                </form>}
                onClose={() => { reset(); setOpen(false); setFormComponent(null) }}

            />
            }
        </>
    );
});
